import { rootApi } from '@/store/api'
import { Tariff } from '@/features/billing/types'

const enhanceApi = rootApi.enhanceEndpoints({ addTagTypes: ['BillingTariffs'] })

export const billingTariffsApi = enhanceApi.injectEndpoints({
  endpoints: (builder) => ({
    billingTariffsList: builder.query<Tariff[], any>({
      query: () => ({
        url: `tariffs`,
      }),
      transformResponse: (response: any) => {
        return response?.data
      },
    }),
  }),
  overrideExisting: false,
})

export const { useBillingTariffsListQuery } = billingTariffsApi
